import { useFormikContext } from 'formik';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { IconBack } from '../../../../../component/IconSvg';
import { ORDER_TYPE_ID } from '../../../../../utils/Constant';
import { parseJSON } from '../../../../../utils/FormatUtils';
import InfoPatientRight from '../../../../components/InfoPatientRight';
import ModalKeVatTu from '../../../modal-ke-vat-tu/ModalKeVatTu';
import { ServiceTemplateButton } from '../../../../components/service-template-button';

type Props = {
	generalInfo: any;
	onClose: () => void;
	tableData: any[];
	setTableData: (data: any[]) => void;
};

const OrderHeader = ({ generalInfo = {}, onClose, tableData, setTableData }: Props) => {
	const { patient, visit } = generalInfo;
	const { values: formValues, setFieldValue } = useFormikContext<any>();
	const [openModalKeVatTu, setOpenModalKeVatTu] = useState(false);
	const DRUG_ORDER_TYPE = parseInt(ORDER_TYPE_ID.THUOC);

	const getDonMauParams = () => {
		const formValue = JSON.stringify(formValues?.orderInfo);
		const tableValue = tableData.map((row) => ({
			orderType: DRUG_ORDER_TYPE,
			orderTemplate: JSON.stringify({
				...row,
				inventoryItemId: null
			}),
		}));

		return {
			orderType: DRUG_ORDER_TYPE,
			orderTemplate: formValue,
			lstOrderSetMemebers: tableValue,
		};
	};

	const onSelectMauChiDinhThuoc = (data: any) => {
		const tableValue = data.lstOrderSetMemebers.map((row: any) => ({
			...JSON.parse(row.orderTemplate),
		}));
		const orderTemplateData = parseJSON(data.orderTemplate);
		setFieldValue("orderInfo", {
			...formValues?.orderInfo,
			warehouse: orderTemplateData.warehouse,
		});
		setTableData(tableValue);

	};

	const saveDonMauValidation = () => {
		if (!tableData.length) {
			toast.warn('Chưa có thuốc được kê cho mẫu này');
			return false;
		}

		return true;
	};

	const selectDonMauValidation = () => {
		if (tableData.length) {
			toast.warn('Đã có thuốc được chỉ định. Không thể chọn đơn mẫu');
			return false;
		}
		return true;
	};

	return (
		<div className='w-100 d-flex justify-content-between'>
			<div className="d-flex align-items-center gap-6">
				<Button variant="bg-transparent ps-0 d-flex align-items-center" onClick={onClose}>
					<IconBack />
					<span className="fw-500 ps-2">Quay lại</span>
				</Button>
				<div className="d-flex spaces gap-10">
					<ServiceTemplateButton
						label="Đơn thuốc mẫu"
						getSaveParams={getDonMauParams}
						onSelectMau={onSelectMauChiDinhThuoc}
						orderType={DRUG_ORDER_TYPE}
						onSaveValidationFn={saveDonMauValidation}
						onSelectValidationFn={selectDonMauValidation}
					/>
					<Button
						className="btn-fill spaces min-w-76"
						onClick={() => {
							setOpenModalKeVatTu(true);
						}}
					>
						Kê vật tư
					</Button>
				</div>
			</div>
			{patient && visit ? (
				<InfoPatientRight
					benhNhanInfo={
						{
							patient,
							visit,
						} as any
					}
				/>
			) : (
				<div className="spaces h-65"></div>
			)}

			{openModalKeVatTu && (
				<ModalKeVatTu
					open={openModalKeVatTu}
					handleClose={() => {
						setOpenModalKeVatTu(false);
					}}
					generalInfo={generalInfo}
				/>
			)}
		</div>
	);
};

export default OrderHeader;
